import React from "react";
import { Link, RichText } from "prismic-reactjs";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import linkResolver from "../helpers/linkResolver";
import isValidLink from "../helpers/isValidLink";

export default function RenderTextSection(slice) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("600"));

  const bgImage = isMobile
    ? slice.primary.mobile_background_image.url
    : slice.primary.desktop_background_image.url;

  const backgroundStyle = {
    background: slice.primary.background_color,
    color: slice.primary.text_color,
  };

  const ctaText = slice.primary.cta_text;
  const ctaLink = slice.primary.cta_link;

  return (
    <section
      className="text-section standard-padding gray-headlines-and-copy"
      style={backgroundStyle}
    >
      <div className="wrapper">
        <RichText render={slice.primary.content} />
        {isValidLink(ctaLink, ctaText) && (
          <div className={`button-wrapper ${slice.primary.cta_alignment}`}>
            <a
              href={Link.url(ctaLink, linkResolver)}
              className={`button solid-black`}
              target={ctaLink.target}
            >
              {ctaText[0].text}
            </a>
          </div>
        )}

        {bgImage && (
          <div className="image-wrapper animate">
            <img src={bgImage} alt="background"/>
          </div>
        )}
      </div>
    </section>
  );
}
